import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Char19o2r8palgjof as Char } from '../Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntIteratorClass;
function IntIterator() {
  if (IntIteratorClass === VOID) {
    class $ {
      r1() {
        return this.nk();
      }
    }
    initMetadataForClass($, 'IntIterator');
    IntIteratorClass = $;
  }
  return IntIteratorClass;
}
var CharIteratorClass;
function CharIterator() {
  if (CharIteratorClass === VOID) {
    class $ {
      ok() {
        return this.pk();
      }
      r1() {
        return new (Char())(this.ok());
      }
    }
    initMetadataForClass($, 'CharIterator');
    CharIteratorClass = $;
  }
  return CharIteratorClass;
}
//region block: exports
export {
  CharIterator as CharIterator2h6gbyxoj1es2,
  IntIterator as IntIteratordtlvcwxsuu5a,
};
//endregion

//# sourceMappingURL=PrimitiveIterators.mjs.map
